<template>
  <div class>
    <div class="activeCode ba_f">
      <div class="service">
        <div class="tit">{{ $t('activation.title') }}</div>
        <div class="cont">
          <input v-model="auth_code" type name class="code" :placeholder="$t('activation.enterCode')" />
          <button class="buy" @click="submitAtuh">
            <span>{{ $t('activation.useNow') }}</span>
          </button>
        </div>
        <ul class="tipps">
          <li>
            <p class="q">{{ $t('activation.faq1q') }}</p>
            <p><span class="colory">{{ $t('activation.answerPrefix') }}</span>{{ $t('activation.faq1a') }}</p>
          </li>
          <li>
            <p class="q">{{ $t('activation.faq2q') }}</p>
            <p><span class="colory">{{ $t('activation.answerPrefix') }}</span>{{ $t('activation.faq2a') }}</p>
          </li>
          <li>
            <p class="q">{{ $t('activation.faq3q') }}</p>
            <p><span class="colory">{{ $t('activation.answerPrefix') }}</span>{{ $t('activation.faq3a') }}</p>
          </li>
          <li>
            <p class="q">{{ $t('activation.faq4q') }}</p>
            <p><span class="colory">{{ $t('activation.answerPrefix') }}</span>{{ $t('activation.faq4a') }}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { checkAuth } from '@/api/set';
export default {
  name: 'activationcode',
  data() {
    return {
      auth_code: ''
    };
  },
  methods: {
    async submitAtuh() {
      if (this.auth_code) {
        const { type, msg } = await checkAuth({ auth_code: this.auth_code });
        this.$baseMessage(msg, 'success');
        if (type == '1') {
          this.$router.push({ path: '/' });
        }
      } else {
        this.$baseMessage(this.$t('activation.enterCode'), 'warning');
      }
    }
  }
};
</script>
